import LinkLogReportModal from "./LinkLogReportModal";
export default LinkLogReportModal;
